import { Controller } from "stimulus";
import { loadScript } from "../util/load_script";

export default class extends Controller {

  connect() {
    loadScript()
      .urls([
        "https://widgets.coingecko.com/coingecko-yield-farming-apy-widget.js",
        "https://widgets.coingecko.com/coingecko-yield-farming-impermanent-loss-calculator-widget.js"
      ]);
  }
}
